import { createSlice } from "@reduxjs/toolkit";

const messagesSlice = createSlice({
  name: "messages",
  initialState: {
    messages: [],
    loadingMessages: [],
    cachedMessages: { sellers: {}, customers: {} },
    currentChat: {
      name: '',
      avatar: '',
      status: ''
    }
    // recentMessages: [{ senderId: 0, receiverID: 0, message: "" }],
  },
  reducers: {
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.unshift(action.payload);
    },
    addMessagePagination: (state, action) => {
      state.messages = state.messages.concat(action.payload);
    },
    updateConvMessage: (state, action) => {
      console.log('Loading Messages ', state.loadingMessages.length)
      if (state.loadingMessages.length === 0) {
        state.messages.unshift(action.payload);
      } else {
        state.messages.splice(0, 1, action.payload)
        state.loadingMessages = []
      }
    },
    addLoadingMessage: (state, action) => {
      state.loadingMessages.push(action.payload);
    },
    cacheMessages(state, action) {
      const { conversationId, chatData, chat, isSeller, append = false, current_page = 0 } = action.payload
      const currContext = isSeller ? 'sellers' : 'customers'
      if (append) {
        state.cachedMessages[currContext][conversationId]['data'] = state.cachedMessages[currContext][conversationId]['data'].concat(chat)
        state.cachedMessages[currContext][conversationId]['current_page'] = current_page
      } else {
        state.cachedMessages[currContext][conversationId] = { ...chatData };
      }
    },
    updateMessageFromSocket(state, action) {
      const { message, userId } = action.payload
      const currContext = message.customer.id === userId ? 'sellers' : 'customers'
      state.cachedMessages?.[currContext]?.[currContext === 'sellers' ? message.seller.id : message.customer.id]?.data.unshift(message);
    },
    updateCurrentUserData(state, action) {
      const { name, avatar, status } = action.payload

      state.currentChat = { name, avatar, status }

    }


    // setRecentMessage: (state, action) => {
    //   state.recentMessages = action.payload;
    // },
  },
});

export const {
  setMessages,
  addMessage,
  addMessagePagination,
  updateConvMessage,
  addLoadingMessage,
  cacheMessages,
  updateMessageFromSocket,
  updateCurrentUserData
  // setRecentMessage,
} = messagesSlice.actions;
export default messagesSlice.reducer;
